import React from 'react'
import { trans } from 'sharedKernel/i18n'
import { EcosystemTermsLink } from './style'
import { showModal } from 'components/popup'
import { LabeledCheckbox } from 'components/LabeledCheckbox'

export interface EcosystemTermsProps {
  checked: boolean
  onCheck: (event: any) => void
}

export const EcosystemTerms = ({ checked, onCheck }: EcosystemTermsProps): JSX.Element => {
  const labels = {
    ecosystemTermsAgreement: trans('Autorizo minha participação no '),
    ecosystemTermsLink: trans('ecossistema de inovação do IEBT Innovation'),
    ecosystemTerms: trans(', por meio da plataforma Zing.'),
    ecosystemTermsTitle: trans('Ecossistema de Inovação IEBT Innovation'),
    failureGetEcosystemTerms: trans('Termos de uso indisponível, tente novamente mais tarde.'),
    firstParagraph: trans('Pelo presente Termo, a empresa abaixo identificada, doravante denominada "STARTUP", declara ter lido, compreendido e aceitado os termos aqui descritos, consentindo com a inclusão de seus dados no Ecossistema da Plataforma Zing, mantida pelo IEBT Innovation, CNPJ nº 11.053.814/0001-00, com sede na Rua Professor José Vieira de Mendonça, nº 770, sala 408 - Engenho Nogueira, Belo Horizonte/MG.'),
    firstTitle: trans('1. OBJETIVO'),
    secondParagraph: trans('A STARTUP autoriza a coleta, uso e divulgação de seus dados pela Plataforma Zing com o objetivo de promover conexões com investidores, empresas e demais agentes do ecossistema de inovação.'),
    secondTitle: trans('2. DADOS QUE PODERÃO SER DIVULGADOS'),
    thirdParagraph: trans('Estágio de desenvolvimento; Faturamento; Histórico de captação; Vertical ou setor de atuação; Modelo de negócio; Número de colaboradores; Tecnologias utilizadas; Descrição para pitch; E-mail, telefone e endereço comercial.'),
    thirdTitle: trans('3. USO DAS INFORMAÇÕES'),
    fourthParagraph: trans('Os dados poderão ser publicados na plataforma, compartilhados com parceiros estratégicos e utilizados em relatórios e comunicações do ecossistema, sempre respeitando a finalidade de promoção da starup.'),
    fourthTitle: trans('4. PRIVACIDADE E DADOS PESSOAIS'),
    fifthParagraph: trans('A Plataforma Zing seguirá as diretrizes da LGPD. Dados pessoais só serão usados com finalidade legítima e consentimento claro. A STARTUP pode solicitar a alteração ou remoção de dados a qualquer momento.'),
    fifthTitle: trans('5. VIGÊNCIA'),
    sixthParagraph: trans('O consentimento é válido enquanto a STARTUP desejar permanecer no ecossistema. A exclusão pode ser solicitada a qualquer momento por e-mail.'),
    sixthTitle: trans('6. DISPOSIÇÕES FINAIS'),
    seventhParagraph: trans('Esse termo não gera vínculo contratual, societário ou transferência de propriedade intelectual. O foro de Belo Horizonte/MG fica eleito para eventuais questões legais.')
  }

  const getEcosystemTermsLink = (): JSX.Element => {
    return (
      <>
        <span>{labels.ecosystemTermsAgreement}</span>
        <EcosystemTermsLink
          onClick={() => {
            renderEcosystemTermsModal()
          }}>
          {labels.ecosystemTermsLink}
        </EcosystemTermsLink>
        <span>{labels.ecosystemTerms}</span>
      </>
    )
  }

  const renderEcosystemTermsModal = (): void => {
    showModal('single', {
      title: labels.ecosystemTermsTitle,
      message: getEcosystemTermsContent()
    })
  }

  const getEcosystemTermsContent = (): JSX.Element => {
    return (
      <div>
        <p>{labels.firstParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.firstTitle}</h6>
        <p>{labels.secondParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.secondTitle}</h6>
        <p>{labels.thirdParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.thirdTitle}</h6>
        <p>{labels.fourthParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.fourthTitle}</h6>
        <p>{labels.fifthParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.fifthTitle}</h6>
        <p>{labels.sixthParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.sixthTitle}</h6>
        <p>{labels.seventhParagraph}</p>
      </div>
    )
  }

  return (
    <>
      <LabeledCheckbox
        id="AcceptEcosystemTerms"
        checked={checked}
        label={getEcosystemTermsLink()}
        onChange={(event) => {
          onCheck(event)
        }}
      />
    </>
  )
}
